<template>
  <div>
    <div style="overflow-x: auto; overflow-y: hidden">
      <div>
        <v-card
          elevation="0"
          class="rounded-lg primary--text"
          style="min-width: 100%; max-width: fit-content; width: fit-content"
        >
          <div
            class="text-center d-flex align-center py-2"
            style="min-height: 65px; width: fit-content"
          >
            <div class="text-start ps-6" style="width: 100px">
              {{ $t("reports.matrix.sNo") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("user.civilIdOrPassport") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("reports.employee") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("user.department") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("user.designation") }}
            </div>
            <div
              class="text-start"
              style="width: 300px"
              v-for="(course, index) in courses"
              :key="index"
            >
              <!-- <div class="font-weight-medium">{{ $t("course.course") }}</div> -->
              <div class="text-ellipse-2">
                {{ getLocalisedValue(course.title) }}
              </div>
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="loading" class="d-flex justify-center my-6">
        <v-progress-circular indeterminate color="primary">
        </v-progress-circular>
      </div>

      <div v-else-if="!loading && trainingMatrixReports.length">
        <div
          v-for="(trainingMatrix, index) in trainingMatrixReports"
          :key="index"
          class="pt-5"
        >
          <v-card
            elevation="0"
            class="rounded-lg textLight--text"
            style="min-width: 100%; max-width: fit-content; width: fit-content"
          >
            <div
              class="text-center d-flex align-center py-2"
              style="min-height: 65px; width: fit-content"
            >
              <div class="text-start ps-6 text-ellipse-2" style="width: 100px">
                {{ index + 1 }}
              </div>
              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  trainingMatrix &&
                  trainingMatrix.employee &&
                  trainingMatrix.employee.user &&
                  trainingMatrix.employee.user.civilIdOrPassport
                    ? trainingMatrix.employee.user.civilIdOrPassport
                    : " - "
                }}
              </div>
              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  trainingMatrix &&
                  trainingMatrix.employee &&
                  trainingMatrix.employee.user &&
                  trainingMatrix.employee.user.firstName
                    ? `${trainingMatrix.employee.user.firstName || ""} ${
                        trainingMatrix.employee.user.lastName || ""
                      }`
                    : " - "
                }}
              </div>
              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  trainingMatrix &&
                  trainingMatrix.employee &&
                  trainingMatrix.employee.department
                    ? trainingMatrix.employee.department
                    : " - "
                }}
              </div>
              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  trainingMatrix &&
                  trainingMatrix.employee &&
                  trainingMatrix.employee.designation
                    ? trainingMatrix.employee.designation
                    : " - "
                }}
              </div>
              <div
                class="text-start"
                style="width: 300px"
                v-for="(course, index) in courses"
                :key="index"
              >
                <div>
                  {{
                    trainingMatrix
                      ? findTrainingRegistrations(course._id, trainingMatrix)
                      : " - "
                  }}
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </div>

      <div
        v-else-if="!loading && !trainingMatrixReports.length"
        class="textLight--text font-weight-medium"
        align="center"
      >
        {{ $t("noItems") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    trainingMatrixReports: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: true,
      type: Boolean,
    },
    courses: {
      type: Array,
      default: () => [],
    },
    startDatePriority: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    findTrainingRegistrations(courseId, trainingMatrixData) {
      let trainingRegistrations =
        trainingMatrixData?.trainingRegistrations ?? [];
      if (courseId && trainingRegistrations?.length) {
        let findRegistrations = trainingRegistrations.filter(
          obj => obj?.training?._id === courseId
        );

        let result = "";
        if (findRegistrations?.length) {
          let sortedArr = findRegistrations.sort(
            (a, b) =>
              parseInt(
                this.startDatePriority
                  ? b?.startDate
                  : b?.trainingCertificate?.expiresAt
              ) -
              parseInt(
                this.startDatePriority
                  ? a?.startDate
                  : a?.trainingCertificate?.expiresAt
              )
          );
          let datesArr = sortedArr
            .map(val => {
              if (this.startDatePriority)
                return val?.startDate
                  ? this.$moment(parseInt(val.startDate)).format("DD MMM YYYY")
                  : null;
              else
                return val?.trainingCertificate?.expiresAt
                  ? this.$moment(
                      parseInt(val.trainingCertificate.expiresAt)
                    ).format("DD MMM YYYY")
                  : null;
            })
            .filter(d => d);

          result = datesArr?.length ? datesArr[0] : "";

          // findRegistrations.map((val, index) => {
          //   result = result.concat(
          //     index > 0 ? ", " : "",
          //     this.$moment(
          //       parseInt(this.startDatePriority ? val?.startDate : val?.endDate)
          //     ).format("DD MMM YYYY")
          //   );
          // });
        }
        if (result && result !== "") return result;
        else return " - ";
      } else return " - ";
    },
  },
};
</script>
